import React, { useState } from 'react';
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import MenuBar from "../menubar/MenuBar";
import CustomerAdd from "../masters/customer/CustomerAdd";
import '../../index.css';
import { Box, CssBaseline } from '@mui/material';
// import DepotWiseSummary from '../reportnew/DepotWise/DepotWiseSummary';
import CustomerList from "../masters/customer/CustomerList";
import CylinderList from "../masters/cylinder/CylinderList";
import CylinderAdd from "../masters/cylinder/CylinderAdd";
import CylinderLocationEntry from "../masters/cylinder/CylinderLocationEntry";
import CylHoldingLimitList from "../masters/cylHoldingLimit/CylHoldingLimitList";
import CylHoldingLimitAdd from "../masters/cylHoldingLimit/CylHoldingLimitAdd";
import UOMList from "../masters/uom/UOMList";
import UOMAdd from "../masters/uom/UOMAdd";
import UOMConversionList from "../masters/uomConversion/UOMConversionList";
import IndustryList from "../masters/industry/IndustryList";
import UOMConversionAdd from "../masters/uomConversion/UOMConversionAdd";
import AccountManagerList from "../masters/accountManager/AccountManagerList";
import AccountManagerAdd from "../masters/accountManager/AccountManagerAdd";
import UnitList from "../masters/unit/UnitList";
import UnitAdd from "../masters/unit/UnitAdd";
import DepotList from "../masters/depot/DepotList"
import DepotAdd from "../masters/depot/DepotAdd";
import RateList from "../masters/rate/RateList";
import RateAdd from "../masters/rate/RateAdd";
import RMList from "../masters/rm/RMList";
import RMAdd from "../masters/rm/RMAdd";
import IndustryAdd from "../masters/industry/IndustryAdd";
import CylinderDetails from "../masters/cylinder/CylinderDetails";
import ProductList from "../masters/product/ProductList";
import ProductAdd from "../masters/product/ProductAdd";
import CustomerDetails from "../masters/customer/CustomerDetails";
import CYLTrackingLogin from "../login/CYLTrackingLogin";
import DeliveryChallanList from "../transactions/deliveryChallan/DeliveryChallanList";
import DeliveryChallanAdd from "../transactions/deliveryChallan/DeliveryChallanAdd";
import ChallanReport from '../reportnew/Challan Report/ChallanReport';
//import CustomerPoList from "../salesEntries/entries/CustomerPoList";
//import CustomerPoAdd from "../salesEntries/entries/CustomerPoAdd";
import DriverList from "../masters/driver/DriverList";
import DriverAdd from "../masters/driver/DriverAdd";
//import CustomerPoDetails from "../salesEntries/entries/CustomerPoDetails";
import GRNList from "../transactions/grn/GRNList";
import GRNAdd from "../transactions/grn/GRNAdd";
import SupplierList from "../masters/supplier/SupplierList";
import SupplierAdd from "../masters/supplier/SupplierAdd";
import GRNDetails from "../transactions/grn/GRNDetails";
// import DeliveryChallanDetails from "../transactions/deliveryChallan/DeliveryChallanDetails";
import ProductionPlanningDetails from "../productionEntries/productionPlanning/ProductionPlanningDetails";
import CylinderInwardAdd from "../storeEntries/cylinderInward/CylinderInwardAdd";
import CylinderInwardList from "../storeEntries/cylinderInward/CylinderInwardList";
// import CylinderInwardDetails from "../storeEntries/cylinderInward/CylinderInwardDetails";
import BomList from "../utility/bom/bomList";
import BomAdd from "../utility/bom/bomAdd";
import ScheduleEntryList from "../salesEntries/entries/ScheduleEntryList";
import ScheduleEntryAdd from "../salesEntries/entries/ScheduleEntryAdd";
// import ScheduleEntryDetails from "../salesEntries/entries/ScheduleEntryDetails";
import Dashboard from "../dashboard/Dashboard";
import CustomerTypeList from "../masters/customerType/CustomerTypeList";
import CustomerTypeAdd from "../masters/customerType/CustomerTypeAdd";
import CylinderStatusList from "../masters/cylinderStatus/CylinderStatusList";
import CylinderStatusAdd from "../masters/cylinderStatus/CylinderStatusAdd";
import ProductionEntryList from "../productionEntries/productionEntry/ProductionEntryList";
import ProductionEntryAdd from "../productionEntries/productionEntry/ProductionEntryAdd";
import ProductionEntryDetails from "../productionEntries/productionEntry/ProductionEntryDetails";
import QualityEntryList from "../productionEntries/qualityEntry/QualityEntryList";
import QualityEntryAdd from "../productionEntries/qualityEntry/QualityEntryAdd";
import QualityEntryDetails from "../productionEntries/qualityEntry/QualityEntryDetails";
import ViewScheduleList from "../productionEntries/viewSchedule/ViewScheduleList";
import DeliveryOrderList from "../transactions/deliveryOrder/DeliveryOrderList";
import DeliveryOrderAdd from "../transactions/deliveryOrder/DeliveryOrderAdd";
import DeliveryOrderDetails from "../transactions/deliveryOrder/DeliveryOrderDetails";
import LocationList from "../masters/location/LocationList";
import LocationAdd from "../masters/location/LocationAdd";
import CustomerProductAdd from "../masters/customerProduct/CustomerProductAdd";
import CustomerProductList from "../masters/customerProduct/CustomerProductList";
import EmptyCylinderInspectionList from "../storeEntries/emptyCylinderInspection/EmptyCylinderInspectionList";
import EmptyCylinderInspectionAdd from '../storeEntries/emptyCylinderInspection/EmptyCylinderInspectionAdd';
// import EmptyCylinderInspectionAdd from "../storeEntries/emptyCylinderInspection/EmptyCylinderInspectionAdd_od";
import InternalMovementList from "../storeEntries/internalMovement/InternalMovementList";
import InternalMovementAdd from "../storeEntries/internalMovement/InternalMovementAdd";
import FinishedGoodReport from "../salesEntries/report/FinishedGood";
import EmptyCylinderReport from "../salesEntries/report/EmptyCylinder";
import CylinderUnderMaintenanceReport from "../salesEntries/report/CylinderUnderMaintenance";
import InventoryFinishedGoodReport from "../salesEntries/report/InventoryFinishedGood";
import SummaryReport from "../salesEntries/report/SummaryReport";
import VehicleList from "../masters/vehicle/VehicleList";
import VehicleAdd from "../masters/vehicle/VehicleAdd";
import RouteList from "../masters/route/RouteList";
import RouteAdd from "../masters/route/RouteAdd";
import UserAdd from "../masters/user/UserAdd";
import UserList from "../masters/user/UserList";
import ListCyltagmap from "../masters/cylinder_tag_mapping/ListCyltagmap";
import Addcyltagmap from "../masters/cylinder_tag_mapping/Addcyltagmap";
import DeliveryChallanCustomerAdd from '../transactions/deliveryChallancustomer/DeliveryChallanCustomerAdd'
import DeliveryChallanCustomerList from '../transactions/deliveryChallancustomer/DeliveryChallanCustomerList'
import AddPickupentry from '../storeEntries/pickup/AddPickupentry';
import Listpickupentry from '../storeEntries/pickup/Listpickupentry';

import Header from '../Header/Header';
import HeaderSection from '../reusableComponent/HeaderSection';
import Masters from '../masters/MastersMain/Masters';
import Addsalesorder from '../salesEntries/sales_order/Addsalesorder';
import Listsalesorder from "../salesEntries/sales_order/Listsalesorder";
import ProductionPlanningList from "../productionEntries/productionPlanning/ProductionPlanningList";
import ProductionPlanningAdd from "../productionEntries/productionPlanning/ProductionPlanningAdd";
import Pending_Sales_Order from "../storeEntries/Pending_Sales_Order/Pending_Sales_Order";
import PendingSalesOrderPrint from '../storeEntries/Pending_Sales_Order/PendingSalesOrderPrint';
import List_tempo_loadings from '../storeEntries/Tempo_loadings/List_tempo_loadings';
import Add_tempo_loadings from '../storeEntries/Tempo_loadings/Add_tempo_loadings';
import AddDeliveryEntry from '../productionEntries/Delivery Acknowlagment/AddDeliveryEntry';
import ListDeliveryEntry from '../productionEntries/Delivery Acknowlagment/ListDeliveryentry'
import Distribution_Master from '../report/Distribution_Master/Distribution_Master';
import Monthly_Distribution_Report from '../report/Monthly_Distribution_Report/Monthly_Distribution_Report';
import Logistics from '../report/Logistics/Logistics';
import Monthly_Logistics_Report from '../report/Monthly_Logistics_Report/Monthly_Logistics_Report';
import Daily_Distribution_Report from '../report/Daily_Distribution_Report/Daily_Distribution_Report';
import EmptyCylinderInventory from '../report/Inventory_List/EmptyCylinderInventory';
import Addmaintenance from '../transactions/maintenance/Addmaintenance';
import MaintenanceList from '../transactions/maintenance/Listmaintenance';
import AddRmIssu from '../productionEntries/RmIssue/AddRmIssu';
// import AddRmssue from '../productionEntries/Rm Issue/AddRmIssu';
import ListRmissue from '../productionEntries/RmIssue/ListRmIssue';
import StockImport from '../transactions/stock/StockImport';
import AddLoadingSlip from '../transactions/loadingSlip/AddLoadingSlip';
import AddEmptyDeliveryChallan from '../transactions/empty_delivery_challan/AddEmptyDeliveryChallan'
import ListEmptyDeliveryChallan from '../transactions/empty_delivery_challan/ListEmpty Delivery Challan';
import Addtransertoplant from '../storeEntries/transfer_plant_entry/Add_transfer_plant_entry';
import Listtransertoplant from '../storeEntries/transfer_plant_entry/List_transafer_to_plant';
import AddTransferToDepot from '../storeEntries/transfer_depot_entry/Add_transfer_to_depot';
import ListTransferToDepot from '../storeEntries/transfer_depot_entry/List_transfer_to_depot';
import ViewCyl_Stock from '../salesEntries/ViewCyl_Stock/ViewCyl_Stock';
import RMStock from '../productionEntries/RMStock/RMStock';
import Addplant from '../masters/plant/PlantAdd';
import Listplant from '../masters/plant/PlantList';
import Newreceipt from '../storeEntries/NewReceipt/new_receipt_list';

import Emptynewcollection from '../transactions/Empty _collection_new_report/Empty_collection';
import DailyDistributionReport from '../reportnew/Daily_Distribution_Report/DailyDistributionReport';
import CylinderUnderMaintenance from '../reportnew/cylinder_under_maintaince/CylinderUnderMaintenance';
import CylinderInventory from '../reportnew/Inventory_List/EmptyCylinderInventory';
import FinishedGoodInventory from '../reportnew/Inventory_List/Finished_Good_Inventory';
import Emptycylinderholding from '../reportnew/custmoer_holding_report/Cutomerholdingreport';
import InspectionReport from '../reportnew/Insepction report/Inspection_report';
import Prodductionreport from '../reportnew/Production Report/production_report';
import Qualitycontroreport from '../reportnew/QC Report/Quality_control_report';
import QuickSearch from '../reportnew/Quick Search/quick_search';
import CylinderInwardDetails from '../storeEntries/cylinderInward/CylinderInwardDetails';
import EmptyCylinderInspectionDeatils from '../storeEntries/emptyCylinderInspection/EmptyCylinderInspectionDetails';
import EmptyCollection from '../transactions/Empty_collection/Empty_collection_list';
import MRReport from '../reportnew/MR/Mrreport';
import EmptyChallanReport from '../reportnew/Challan Report/EmptyChallanReport';
import Deliveryacknowledgemet from '../reportnew/delivery_Aknowledgment/Delivery_aknowledgment';
import EmptyCollectionList from '../transactions/Empty_collection/Empty_collection_list';
import AddDeliveryActivityplanning  from '../storeEntries/Delivery Activity planning/Adddeliveryactivity';
import ListDriverActivityPlaning from '../storeEntries/Delivery Activity planning/ListDriverActivrtyPlanning';
import ListSalesreturn from '../transactions/SalesReturns/Listsalesreturn';
import AddEmptycollection  from '../transactions/Empty_collection/Add_Empty_collection';
import OpeingBalance from '../reportnew/Opening Balance/Opeing_balance_report';
import CustomerStatement from '../transactions/Customer_Statment/Customer_statement';
import Maintainance from '../reportnew/Maintainance Report/Maintainance_report';
import SalesreportSerivces from '../reportnew/Sales report/Sales_report';
import OperatorList from "../masters/operator/OperatorList";
import OperatorAdd  from "../masters/operator/OperatorAdd";
import ProductionQuantityReport from '../reportnew/Production Quantity Report/ProductionQuantityReport';
import CustomerHoldingSummary from '../reportnew/custmoer_holding_report/CustomerHoldingSummary';
import SOSummaryReport from "../salesEntries/sales_order/SOSummaryReport";




const CTSroutes = () => {
    const [mobileOpen, setMobileOpen] = useState(false);
    const [isDrawerOpen, setIsDrawerOpen] = useState(true); // Track drawer state for desktop

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const handleDrawerWidthToggle = () => {
        setIsDrawerOpen(!isDrawerOpen); // Toggle desktop drawer state
    };

    const drawerWidth = {
        xs: 230,
        sm: 230,
        md: 230,
        lg: 230,
        xl: 230,
    };

    const miniDrawerWidth = {
        md: 60,
        lg: 70,
        xl: 80,
    };

    const MainContent = ({ children }) => {
        const login_details = sessionStorage.getItem('loginUser');
        let userInfo = null;

        if (login_details) {
            try {
                const userD = JSON.parse(login_details);
                userInfo = userD?.result?.userInfo || null;
            } catch (err) {
                console.error("Invalid session data", err);
            }
        }

        if (!userInfo) {
            return <Navigate to="/" replace />;
        }

        return (
            <Box
                sx={{
                    flexGrow: 1,
                    width: {
                        xs: '100%',
                        sm: '100%',
                        md: `calc(100% - ${isDrawerOpen ? drawerWidth.md : miniDrawerWidth.md}px)`,
                        lg: `calc(100% - ${isDrawerOpen ? drawerWidth.lg : miniDrawerWidth.lg}px)`,
                        xl: `calc(100% - ${isDrawerOpen ? drawerWidth.xl : miniDrawerWidth.xl}px)`,
                    },
                    ml: {
                        xs: 0,
                        sm: 0,
                        md: isDrawerOpen ? `${drawerWidth.md}px` : `${miniDrawerWidth.md}px`,
                        lg: isDrawerOpen ? `${drawerWidth.lg}px` : `${miniDrawerWidth.lg}px`,
                        xl: isDrawerOpen ? `${drawerWidth.xl}px` : `${miniDrawerWidth.xl}px`,
                    },
                    mt: '40px',
                    transition: (theme) =>
                        theme.transitions.create(['margin-left', 'width'], {
                            easing: theme.transitions.easing.sharp,
                            duration: theme.transitions.duration.enteringScreen,
                        }),
                }}
            >
                {children}
            </Box>
        );
    };

    const location = useLocation();
    const isLoginPage = location.pathname === '/';
    return (
        <>
            {/* <Header toggleSidebar={handleDrawerToggle} />
            <MenuBar mobileOpen={mobileOpen} handleDrawerToggle={handleDrawerToggle} /> */}
            <CssBaseline />
            {!isLoginPage && (
                <>
                    <Header toggleSidebar={handleDrawerToggle} />
                    <MenuBar
                        mobileOpen={mobileOpen}
                        handleDrawerToggle={handleDrawerToggle}
                        isDrawerOpen={isDrawerOpen}
                        handleDrawerWidthToggle={handleDrawerWidthToggle}
                    />
                </>
            )}
            <Routes >
                <Route path="/" element={<CYLTrackingLogin />}> </Route>
                {/* <Route path="/" element={ <MainContent> <Dashboard/> </MainContent>}> </Route> */}
                <Route path="/dashboard" element={<MainContent><Dashboard /></MainContent>} />
                {/* <Route path="/dashboard" element={<MainContent> <Dashboard /> </MainContent>}> </Route> */}
                {/* -----------------------Masters ------------------ */}
                {/* <Route path="/HeaderSection" element={<MainContent> <HeaderSection /> </MainContent>}> </Route> */}
                <Route path="/masters/MastersMain/Masters" element={<MainContent> <Masters /> </MainContent>}> </Route>
                <Route path="/masters/list-customer" element={<MainContent> <CustomerList /> </MainContent>}> </Route>
                <Route path="/masters/add-customer" element={<MainContent><CustomerAdd /> </MainContent>}> </Route>
                <Route path="/masters/list-supplier" element={<MainContent> <SupplierList /> </MainContent>}> </Route>
                <Route path="/masters/add-supplier" element={<MainContent><SupplierAdd /> </MainContent>}> </Route>
                <Route path="/masters/details-customer" element={<MainContent><CustomerDetails /> </MainContent>}> </Route>
                <Route path="/masters/list-cylinder" element={<MainContent> <CylinderList /> </MainContent>}> </Route>
                <Route path="/masters/add-cylinder" element={<MainContent><CylinderAdd /> </MainContent>}> </Route>
                <Route path="/masters/cylinder-location-entry" element={<MainContent><CylinderLocationEntry /> </MainContent>}> </Route>
                <Route path="/masters/details-cylinder" element={<MainContent><CylinderDetails /> </MainContent>}> </Route>
                <Route path="/masters/list-cylinder-holding-limit" element={<MainContent> <CylHoldingLimitList /> </MainContent>}> </Route>
                <Route path="/masters/add-cylinder-holding-limit" element={<MainContent><CylHoldingLimitAdd /> </MainContent>}> </Route>
                <Route path="/masters/list-uom" element={<MainContent> <UOMList /> </MainContent>}> </Route>
                <Route path="/masters/add-uom" element={<MainContent><UOMAdd /> </MainContent>}> </Route>
                <Route path="/masters/list-uom-conversion" element={<MainContent> <UOMConversionList /> </MainContent>}> </Route>
                <Route path="/masters/add-uom-conversion" element={<MainContent><UOMConversionAdd /> </MainContent>}> </Route>
                <Route path="/masters/list-account-manager" element={<MainContent> <AccountManagerList /> </MainContent>}> </Route>
                <Route path="/masters/add-account-manager" element={<MainContent><AccountManagerAdd /> </MainContent>}> </Route>
                <Route path="/masters/list-unit" element={<MainContent> <UnitList />  </MainContent>}> </Route>
                <Route path="/masters/add-unit" element={<MainContent> <UnitAdd /> </MainContent>}> </Route>
                <Route path="/masters/list-depot" element={<MainContent> <DepotList />  </MainContent>}> </Route>
                <Route path="/masters/add-depot" element={<MainContent> <DepotAdd /> </MainContent>}> </Route>
                <Route path="/masters/list-rate" element={<MainContent> <RateList /> </MainContent>}> </Route>
                <Route path="/masters/add-rate" element={<MainContent><RateAdd /> </MainContent>}> </Route>
                <Route path="/masters/list-rm" element={<MainContent> <RMList /> </MainContent>}> </Route>
                <Route path="/reportnew/CustomerHoldingSummary" element={<MainContent> <CustomerHoldingSummary /> </MainContent>}></Route>
                <Route path="/masters/add-rm" element={<MainContent><RMAdd /> </MainContent>}> </Route>
                <Route path="/masters/list-industry" element={<MainContent> <IndustryList /> </MainContent>}> </Route>
                <Route path="/masters/add-industry" element={<MainContent><IndustryAdd /> </MainContent>}> </Route>
                <Route path="/masters/list-product" element={<MainContent> <ProductList /> </MainContent>}> </Route>
                <Route path="/masters/add-product" element={<MainContent><ProductAdd /> </MainContent>}> </Route>
                <Route path="/masters/list-driver" element={<MainContent> <DriverList /> </MainContent>}> </Route>
                <Route path="/masters/add-driver" element={<MainContent><DriverAdd /> </MainContent>}> </Route>
                <Route path="/masters/list-customerType" element={<MainContent> <CustomerTypeList /> </MainContent>}> </Route>
                <Route path="/masters/add-customerType" element={<MainContent> <CustomerTypeAdd /> </MainContent>}> </Route>
                <Route path="/masters/list-cylinder_status" element={<MainContent> <CylinderStatusList /> </MainContent>}> </Route>
                <Route path="/masters/add-cylinder_status" element={<MainContent> <CylinderStatusAdd /> </MainContent>}> </Route>
                <Route path="/masters/list-location" element={<MainContent> <LocationList /> </MainContent>}> </Route>
                <Route path="/masters/add-location" element={<MainContent> <LocationAdd /> </MainContent>}> </Route>
                <Route path="/masters/add-cpd" element={<MainContent> <CustomerProductAdd /> </MainContent>}> </Route>
                <Route path="/masters/list-cpd" element={<MainContent> <CustomerProductList /> </MainContent>}> </Route>
                <Route path="/masters/list-vehicle" element={<MainContent> <VehicleList /> </MainContent>}> </Route>
                <Route path="/masters/add-vehicle" element={<MainContent> <VehicleAdd /> </MainContent>}> </Route>
                <Route path="/masters/list-route" element={<MainContent> <RouteList /> </MainContent>}> </Route>
                <Route path="/masters/add-route" element={<MainContent> <RouteAdd /> </MainContent>}> </Route>
                <Route path="/masters/list-user" element={<MainContent> <UserList /> </MainContent>}> </Route>
                <Route path="/masters/add-user" element={<MainContent> <UserAdd /> </MainContent>}> </Route>
                <Route path="/masters/ListCyltagmap" element={<MainContent> <ListCyltagmap /> </MainContent>}> </Route>
                <Route path="/masters/Addcyltagmap" element={<MainContent> <Addcyltagmap /> </MainContent>}> </Route>
                <Route path="/masters/Addplant" element={<MainContent> <Addplant /> </MainContent>}> </Route>
                <Route path="/masters/Listplant" element={<MainContent> <Listplant /> </MainContent>}> </Route>
                <Route path="/masters/list-operator" element={<MainContent><OperatorList /></MainContent>} />
                <Route path="/salesEntries/so-summary" element={<MainContent><SOSummaryReport /></MainContent>}></Route>
<Route path="/masters/add-operator"  element={<MainContent><OperatorAdd  /></MainContent>} />
                {/* ------------------------ Production Entry ---------------------- */}


                <Route path="/productionEntries/list-pp" element={<MainContent><ProductionPlanningList /> </MainContent>}></Route>
                <Route path="/productionEntries/add-pp" element={<MainContent><ProductionPlanningAdd /> </MainContent>}></Route>
                <Route path="/productionEntries/details-pp" element={<MainContent><ProductionPlanningDetails /> </MainContent>}></Route>
                <Route path="/productionEntries/list-pe" element={<MainContent><ProductionEntryList /> </MainContent>}></Route>
                <Route path="/productionEntries/add-pe" element={<MainContent><ProductionEntryAdd /> </MainContent>}></Route>
                <Route path="/productionEntries/details-pe" element={<MainContent><ProductionEntryDetails /> </MainContent>}></Route>
                <Route path="/productionEntries/list-qe" element={<MainContent><QualityEntryList /> </MainContent>}></Route>
                <Route path="/productionEntries/add-qe" element={<MainContent><QualityEntryAdd /> </MainContent>}></Route>
                <Route path="/productionEntries/details-qe" element={<MainContent><QualityEntryDetails /> </MainContent>}></Route>
                <Route path="/transactions/add-maintenance" element={<MainContent><Addmaintenance /> </MainContent>}></Route>
                <Route path="/transactions/list-maintenance" element={<MainContent><MaintenanceList /> </MainContent>}></Route>
                <Route path="/transactions/add-loadingslip" element={<MainContent><AddLoadingSlip /> </MainContent>}></Route>
                <Route path="/productionEntries/AddRmIssu" element={<MainContent><AddRmIssu /> </MainContent>}></Route>
                <Route path="/productionEntries/ListRmissue" element={<MainContent><ListRmissue /> </MainContent>}></Route>
                <Route path="/salesEntries/ViewCyl_Stock" element={<MainContent> <ViewCyl_Stock /> </MainContent>}></Route>
                <Route path="/productionEntries/RMStock" element={<MainContent> <RMStock /> </MainContent>}></Route>
                <Route path="/productionEntries/adddeliveryentry" element={<MainContent> <AddDeliveryEntry /> </MainContent>}></Route>
              


                {/* ------------------------ View Entry ---------------------- */}
                <Route path="/viewEntries/list-vs" element={<MainContent> <ViewScheduleList /> </MainContent>}> </Route>

                {/* ------------------------ Store Entry --------------------------- */}
                  <Route path="/storeEntries/List-dap" element={<MainContent><ListDriverActivityPlaning /> </MainContent>}></Route>
                   <Route path="/storeEntries/add-dap" element={<MainContent><AddDeliveryActivityplanning /> </MainContent>}></Route>
                <Route path="/storeEntries/Addtransertoplant" element={<MainContent><Addtransertoplant /> </MainContent>}></Route>
                <Route path="/storeEntries/Listtransertoplant" element={<MainContent><Listtransertoplant /> </MainContent>}></Route>
                <Route path="/storeEntries/list-transfer-to-depot" element={<MainContent><ListTransferToDepot /></MainContent>}></Route>
                <Route path="/storeEntries/add-transfer-to-depot" element={<MainContent><AddTransferToDepot /></MainContent>}></Route>
                <Route path="/storeEntries/list-eci" element={<MainContent><EmptyCylinderInspectionList /> </MainContent>}></Route>
                <Route path="/storeEntries/add-eci" element={<MainContent><EmptyCylinderInspectionAdd /> </MainContent>}></Route>
                <Route path="/storeEntries/details-eci" element={<MainContent><EmptyCylinderInspectionDeatils /> </MainContent>}></Route>
                <Route path="/storeEntries/list-ime" element={<MainContent><InternalMovementList /> </MainContent>}></Route>
                <Route path="/storeEntries/add-ime" element={<MainContent><InternalMovementAdd /> </MainContent>}></Route>
                <Route path="/transactions/stock" element={<MainContent><StockImport /> </MainContent>}></Route>
                <Route path="/storeEntries/list-ci" element={<MainContent><CylinderInwardList /> </MainContent>}></Route>
                <Route path="/storeEntries/add-ci" element={<MainContent><CylinderInwardAdd /> </MainContent>}></Route>
                {/* <Route path="/storeEntries/details-ci" element={ <MainContent><CylinderInwardDetails /> </MainContent>}></Route> */}
                <Route path="/transactions/list-grn" element={<MainContent> <GRNList />  </MainContent>}> </Route>
                 <Route path="/transactions/listsales" element={<MainContent> <ListSalesreturn />  </MainContent>}> </Route>
                <Route path="/transactions/add-grn" element={<MainContent><GRNAdd />  </MainContent>}> </Route>
                <Route path="/storeEntries/details-grn" element={<MainContent><GRNDetails />  </MainContent>}> </Route>
                <Route path="/storeEntries/add-pickup" element={<MainContent><AddPickupentry />  </MainContent>}> </Route>
                <Route path="/storeEntries/List-pickup" element={<MainContent><Listpickupentry />  </MainContent>}> </Route>
                <Route path="/storeEntries/List-tempo-loading" element={<MainContent><List_tempo_loadings />  </MainContent>}> </Route>
                <Route path="/storeEntries/Add-tempo-loadings" element={<MainContent><Add_tempo_loadings />  </MainContent>}> </Route>
                <Route path="/transactions/add-edc" element={<MainContent><AddEmptyDeliveryChallan /> </MainContent>}></Route>
                <Route path="/transactions/List-edc" element={<MainContent><ListEmptyDeliveryChallan /> </MainContent>}></Route>
                <Route path="/salesEntries/add-so" element={<MainContent><Addsalesorder /> </MainContent>}></Route>
                <Route path="/salesEntries/list-so" element={<MainContent><Listsalesorder /> </MainContent>}></Route>
                <Route path="/storeEntries/Pending_Sales_Order" element={<MainContent><Pending_Sales_Order /> </MainContent>}></Route>
                <Route path="/storeEntries/PendingSalesOrderPrint" element={<MainContent><PendingSalesOrderPrint /> </MainContent>}></Route>
                <Route path="/storeEntries/Adddeliveryentry" element={<MainContent><AddDeliveryEntry /> </MainContent>}></Route>
                <Route path="/productionEntries/ListDeliveryEntry" element={<MainContent><ListDeliveryEntry /> </MainContent>}></Route>
                <Route path="/storeEntries/list-newrc" element={<MainContent><Newreceipt /></MainContent>}></Route>
                {/* <Route path="/productionEntries/add-pe" element={<MainContent><ProductionEntryAdd /> </MainContent>}></Route> */}
                <Route path="/productionEntries/list-qe" element={<MainContent><QualityEntryList /> </MainContent>}></Route>

                {/* ------------------------ Logistic and Distribution --------------------------- */}

                <Route path="/LogisticDistribution/list-dc" element={<MainContent> <DeliveryChallanList />  </MainContent>}> </Route>
                <Route path="/LogisticDistribution/add-dc" element={<MainContent><DeliveryChallanAdd />  </MainContent>}> </Route>
                <Route path="/LogisticDistribution/details-dc" element={<MainContent><DeliveryOrderDetails />  </MainContent>}> </Route>
                {/* <Route path="/LogisticDistribution/details-dc" element={ <MainContent><DeliveryChallanDetails />  </MainContent>}> </Route> */}
                <Route path="/LogisticDistribution/list-do" element={<MainContent> <DeliveryOrderList />  </MainContent>}> </Route>
                <Route path="/LogisticDistribution/add-do" element={<MainContent><DeliveryOrderAdd />  </MainContent>}> </Route>
                <Route path="/LogisticDistribution/details-do" element={<MainContent><DeliveryOrderDetails />  </MainContent>}> </Route>
                <Route path="/LogisticDistribution/add-customerdc" element={<MainContent><DeliveryChallanCustomerAdd />  </MainContent>}> </Route>
                <Route path="/LogisticDistribution/list-customerdc" element={<MainContent><DeliveryChallanCustomerList />  </MainContent>}> </Route>
                {/* ------------------------------------------- Sales Entries -------------------------------------------- */}

                {/* ------------------------ Entries --------------------------- */}

                {/* ------------------------ Customer PO --------------------------- */}

                {/* <Route path="/salesEntries/list-customer-po" element={ <MainContent> <CustomerPoList />  </MainContent>}> </Route>
                <Route path="/salesEntries/add-customer-po" element={ <MainContent><CustomerPoAdd />  </MainContent>}> </Route>
                <Route path="/salesEntries/details-customer-po" element={ <MainContent><CustomerPoDetails />  </MainContent>}> </Route> */}

                {/* ------------------------  Shedule / Customer PO  --------------------------- */}
                <Route path="/salesEntries/list-se" element={<MainContent><ScheduleEntryList /> </MainContent>}></Route>
                <Route path="/salesEntries/add-se" element={<MainContent><ScheduleEntryAdd /> </MainContent>}></Route>
                {/* <Route path="/salesEntries/details-se" element={ <MainContent><ScheduleEntryDetails /> </MainContent>}></Route> */}

                {/* --------------------   Utility      -----------------------*/}
                {/* ------------------------ BOM  --------------------------- */}
                <Route path="/utility/list-bom" element={<MainContent> <BomList /> </MainContent>}></Route>
                <Route path="/utility/add-bom" element={<MainContent> <BomAdd /> </MainContent>}></Route>

                {/* -------------------- Reports -----------------------*/}


                <Route path="/reports/Distribution_Master" element={<MainContent> <Distribution_Master /> </MainContent>}></Route>
                <Route path="/reports/Daily_Distribution_Report" element={<MainContent> <Daily_Distribution_Report /> </MainContent>}></Route>
                <Route path="/reports/Monthly_Distribution_Report" element={<MainContent> <Monthly_Distribution_Report /> </MainContent>}></Route>
                <Route path="/reports/EmptyCylinderInventory" element={<MainContent> <EmptyCylinderInventory /> </MainContent>}></Route>

                {/* <Route path="/reports/Empty_Cylinder_Inventory" element={<MainContent> <Empty_Cylinder_Inventory /> </MainContent>}></Route>
                <Route path="/reports/Cyl_under_maintaince_inv" element={<MainContent> <Cyl_under_maintaince_inv /> </MainContent>}></Route>
                <Route path="/reports/Finished_Goods_Returned" element={<MainContent> <Finished_Goods_Returned /> </MainContent>}></Route>
                <Route path="/reports/Summary_report" element={<MainContent> <Summary_report /> </MainContent>}></Route> */}
                <Route path="/reports/Logistics" element={<MainContent> <Logistics /> </MainContent>}></Route>
                <Route path="/reports/Monthly_Logistics_Report" element={<MainContent> <Monthly_Logistics_Report /> </MainContent>}></Route>

                <Route path="/reports/fg" element={<MainContent> <FinishedGoodReport /> </MainContent>}></Route>
                <Route path="/reports/eci" element={<MainContent> <EmptyCylinderReport /> </MainContent>}></Route>
                <Route path="/reports/cm" element={<MainContent> <CylinderUnderMaintenanceReport /> </MainContent>}></Route>
                <Route path="/reports/ifg" element={<MainContent> <InventoryFinishedGoodReport /> </MainContent>}></Route>
                <Route path="/reports/sr" element={<MainContent> <SummaryReport /> </MainContent>}></Route>


                {/* --------------------New Reports here------------------- */}
                 <Route path="/transactions/addcollection" element={<MainContent> <AddEmptycollection /> </MainContent>}></Route>
                <Route path="/transactions/newcollection" element={<MainContent> <Emptynewcollection /> </MainContent>}></Route>
                <Route path="/transactions/EmptyCollection" element={<MainContent> <EmptyCollectionList /> </MainContent>}></Route>
                <Route path="/reportnew/DailyDistributionReport" element={<MainContent> <DailyDistributionReport /> </MainContent>}></Route>
                <Route path="/reportnew/CylinderUnderMaintenance" element={<MainContent> <CylinderUnderMaintenance /> </MainContent>}></Route>
                <Route path="/reportnew/CylinderInventory" element={<MainContent> <CylinderInventory /> </MainContent>}></Route>
                <Route path="/reportnew/FinishedGoodInventory" element={<MainContent> <FinishedGoodInventory /> </MainContent>}></Route>
                <Route path="/reportnew/EmptyCylinderHolding" element={<MainContent> <Emptycylinderholding /> </MainContent>}></Route>
                <Route path="/reportnew/InspectionReport" element={<MainContent> <InspectionReport /> </MainContent>}></Route>
                <Route path="/reportnew/Prodductionreport" element={<MainContent> <Prodductionreport /> </MainContent>}></Route>
                <Route path="/reportnew/Qualitycontroreport" element={<MainContent> <Qualitycontroreport /> </MainContent>}></Route>
                <Route path="/reportnew/Maintenancereport" element={<MainContent> <CylinderUnderMaintenanceReport /> </MainContent>}></Route>
                <Route path="/reportnew/Challanreport" element={<MainContent> <ChallanReport /> </MainContent>}></Route>
                <Route path="/reportnew/QuickSearch" element={<MainContent> <QuickSearch /> </MainContent>}></Route>
                <Route path="/storeEntries/CylinderInwardDetails" element={<MainContent> <CylinderInwardDetails /> </MainContent>}></Route>
                <Route path="/reportnew/mrreport" element={<MainContent> <MRReport /> </MainContent>}></Route>
                {/* <Route path="/reportnew/depotwise" element={<MainContent> <DepotWiseSummary /> </MainContent>}></Route> */}
                <Route path="/reportnew/emptychallan" element={<MainContent> <EmptyChallanReport /> </MainContent>}></Route>
                <Route path="/reportnew/deliveryacknowledgemet" element={<MainContent> <Deliveryacknowledgemet /> </MainContent>}></Route>
                <Route path="/reportnew/openingbalance" element={<MainContent> <OpeingBalance /> </MainContent>}></Route>
                
                <Route path="/transactions/statement" element={<MainContent> <CustomerStatement/> </MainContent>}></Route>
                <Route path="/reportnew/maintainace" element={<MainContent> <Maintainance /> </MainContent>}></Route>
                <Route path="/reportnew/salesreport" element={<MainContent> <SalesreportSerivces /> </MainContent>}></Route>
                 <Route path="/reportnew/productionquantityreport" element={<MainContent> <ProductionQuantityReport /> </MainContent>}></Route>
            
                
                





            </Routes>

        </>
    )
}

export default CTSroutes;